/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconConfirmation = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-confirmation',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.05 0 2.046.15 2.988.45.941.3 1.812.717 2.612 1.25l-1.525 1.525A8.598 8.598 0 0 0 14.15 4.4c-.683-.2-1.4-.3-2.15-.3-2.183 0-4.046.77-5.588 2.313C4.871 7.954 4.1 9.816 4.1 12s.77 4.046 2.313 5.587C7.954 19.13 9.816 19.9 12 19.9s4.046-.77 5.587-2.313C19.13 16.046 19.9 14.183 19.9 12a7.637 7.637 0 0 0-.15-1.575l1.7-1.7c.183.517.32 1.046.413 1.588.091.541.137 1.104.137 1.687a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm-1.375-5.425-4.275-4.3L7.825 10.8l2.825 2.825 9.875-9.875L22 5.2 10.625 16.575Z" })));
});
IconConfirmation.displayName = 'IconConfirmation';
export default IconConfirmation;
